export default __webpack_public_path__ + "static/media/duster-techroad-large.4ad50b09.jpg";